import { createStore } from '@stencil/store';
import { PersonDoc } from 'common';
import { PeopleService } from '../../global/service/PeopleService';

export interface DocumentsStoreState {
  selectedPeopleIds: string[];
  availablePeopleToDisplay: PersonDoc[];
  firstPeopleIdsRender: boolean;
  people: PersonDoc[];
}

const initialStoreState: DocumentsStoreState = {
  people: [],
  selectedPeopleIds: [],
  availablePeopleToDisplay: [],
  firstPeopleIdsRender: true,
};

export const { state: documentsStoreState, onChange: documentsStoreChange } = createStore<DocumentsStoreState>(initialStoreState);

const sortedPeopleIdsKey = (ids: string[]) => [...ids].filter(Boolean).sort().join('\0');

export const setSelectedPeopleIds = (newState: string[]) => {
  if (sortedPeopleIdsKey(newState) === sortedPeopleIdsKey(documentsStoreState.selectedPeopleIds)) {
    return;
  }
  documentsStoreState.selectedPeopleIds = newState;
};

export const setAvailablePeopleToDisplay = (newState: PersonDoc[]) => {
  documentsStoreState.availablePeopleToDisplay = newState;
};

export const setFirstPeopleIdsRender = (newState: boolean) => {
  documentsStoreState.firstPeopleIdsRender = newState;
};

export const setPeople = (newState: PersonDoc[]) => {
  documentsStoreState.people = newState;
};

export const setHandleAvailablePeopleChange = (peopleIds: string[]) => {
  // some Ids might be undefined, so we need to filter them out
  const filteredSystemIds = peopleIds.filter(id => id !== 'system');
  const differentIds = [...new Set(filteredSystemIds)];
  documentsStoreState.availablePeopleToDisplay = differentIds.map(id => PeopleService.findPerson(documentsStoreState.people, id));
  if (documentsStoreState.firstPeopleIdsRender) {
    setSelectedPeopleIds(differentIds);
    documentsStoreState.firstPeopleIdsRender = false;
  }
};
